import $ from 'jquery';

function init() {
    /**
     * detect if device is in landscape mode
     * @param  {[type]}  obj [description]
     * @return {Boolean}     [description]
     */
    function isLandscape(obj) {
        // if it's Windows Phone
        switch (obj.orientation) {
            case -90:
            case 90:
                return true;
            default:
                return false;
        }
    }

    function showLock() {
        $('.orientation-lock').show();
        $('html').addClass('scroll-lock');
    }

    function hideLock() {
        $('.orientation-lock').hide();
        $('html').removeClass('scroll-lock');
    }

    // detect device position on load
    if ((isLandscape(window)) && ($(window).width() >= 1024)) {
        hideLock();
    } else if (isLandscape(window)) {
        showLock();
    } else {
        hideLock();
    }

    // detect device position on orientation change
    $(window).on('orientationchange', function (e) {
        if ((isLandscape(e.target)) && ($(window).width() >= 1024)) {
            hideLock();
        } else if (isLandscape(e.target)) {
            showLock();
        } else {
            hideLock();
        }
    });
}

export { init };



// WEBPACK FOOTER //
// ./src/_app/layout/orientation-lock.js